export enum AccountType {
    AWS = 0,
    Azure = 1,
}